<template>
  <div class="wrapper">
    <!-- <div v-if="!test">
      <div class="title">
        <span>效果图</span>
 
      </div>
      <br>
      <div class="canvas-wrapper">
        <img :src="imgData" alt="" class="img" />
        <div style="margin-right: 0.625rem; color: #5188fc" class="btn"></div>
        <div class="rewrite">
          <div class="rewrite-msg">
            <cube-button @click="toAutograph">重新书写</cube-button>
          </div>
          <div class="rewrite-sure">
            <cube-button>确定</cube-button>
          </div>
        </div>
      </div>
    
    </div> -->
    <!-- <div v-if="!test" class="resign">
          <img :src="imgData" alt="" class="img" />
      <div style="margin-right: 0.625rem; color: #5188fc" class="btn">
        <p @click="toAutograph">重新签名</p>
        <p>确定</p>

      </div>

    </div> -->
    <div v-if="test">
      <signature @closePop="closePop" @saveImg="complete"></signature>
    </div>
    <van-empty
      v-else
      class="custom-image"
      :image="require('../../assets/images/check-circle-fill@3x.png')"
      :description="description"
    />
  </div>
</template>

<script>
import signature from "../../components/signature.vue";
import { toast } from "@/common/api/api.js";
import configUrl from "../../config/configUrl";
import axios from "axios";
import {
  userLogout,
  delCookie,
  addSignature,
  getSignature,
  getStaffJingCardState,
  saveApprovalSign,
} from "@/common/api";
export default {
  components: {
    signature,
  },
  data() {
    return {
      description: "",
      test: true,
      imgData: "",
      // loginInfo: JSON.parse(window.localStorage.getItem("loginInfo")),
    };
  },
  methods: {
    // getSignature() {
    //   getSignature({ staffId: this.loginInfo.id }).then((res) => {
    //     if (res.code == 200) {
    //       this.imgData = res.data.hosProposalSign;
    //     } else {
    //       this.imgData = "";
    //     }
    //   });
    // },
    toAutograph() {
      this.test = true;
    },
    complete(data) {
      if (data) {
        this.imgData = data;
        let formData = new FormData();
        formData.append("membershipApplicationSignature", this.imgData);
        formData.append("hospitalCode", this.$route.query.hospitalCode);
        formData.append("unitCode", this.$route.query.unitCode);
        formData.append("userId", this.$route.query.id);
        formData.append("identity", this.$route.query.identity);
        formData.append("staffId", this.$route.query.id);

        axios
          .post(
            configUrl.ordinaryUrl +
              "hospitalSignController/saveApprovalSign",
            formData
          )
          .then((res) => {
            console.log(res,'res');
            if (res.data.code == 200) {
              this.test = false;
              this.description = res.data.message;
            } else {
              toast(this, res.message, "error");
            }
          });
        // var data = {
        //   staffId: this.loginInfo.id,
        //   membershipApplicationSignature: this.imgData,
        // };
        // saveApprovalSign(data).then((res) => {
        //   if (res.code == 200) {
        //     this.test = false;
        //     this.description = res.message;
        //   } else {
        //     toast(this, res.message, "error");
        //   }
        // });
      } else {
        toast(this, "请进行电子签名", "error");
      }
    },
    closePop() {
      this.test = false;
      //   this.$router.go(-1);
    },
  },
};
</script>

<style rel="stylesheet/stylus" lang="less" scoped>
.wrapper {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  height: 100vh;
  .title {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #efeff4;
    position: absolute;
    width: 100%;
    top: 40%;
    transform: rotate(270deg);
    left: -167px;
    .close {
      float: right;
      font-size: 20px;
      padding-right: 5px;
    }
  }

  .canvas-wrapper {
    background: #fff;
    .img {
      width: 150px;
      height: 150px;
      position: relative;
      top: 160px;
      right: -110px;
    }
  }

  .rewrite {
    background: #fff;
    display: flex;
    position: relative;
    transform: rotate(270deg);
    top: 70px;
    right: -160px;
    .rewrite-msg {
      flex: 1;
      padding: 10px;
    }
    .rewrite-sure {
      flex: 1;
      padding: 10px;
    }
  }
}
/deep/ .custom-image .van-empty__image {
  width: 90px !important;
  height: 90px !important;
}
/deep/ .van-empty__image img {
  width: 90px !important;
  height: 90px !important;
}
/deep/ .van-empty__description {
  color: #1d2129 !important;
  font-size: 18px;
}
/deep/ .van-empty__description {
  text-align: center;
  font-family: PingFang SC-Medium;
}
</style>
